import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';
import { P } from 'stile-shared/src/components/2020/common/Primitives';

import { PageLayout } from 'templates/2020/PageLayout';
import { SEO } from 'templates/2020/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="New NSW Syllabus"
      description="2026 teacher planning resource"
      slug={props.location.pathname}
    />
  );
}

function NSWSyllabusPage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="New NSW Syllabus"
        subtitle="2026 teacher planning resource"
        id="NSW_SYLLABUS_2026"
        redirectUrl="https://stileapp.com/go/nswsyllabus"
        image={<StaticImage src="../../../../stile-shared/assets/images/nsw/form.png" alt="" />}
      >
        <P>
          Stile is a complete, coherent curriculum for science classrooms in New South Wales. This
          document outlines the changes to the NSW Syllabus and Stile’s alignment to the changes
          over the next two years.
        </P>
        <P>
          Use our Scope and Sequence as a world-class starting point for designing your school’s
          science curriculum. Alongside our helpful teaching plans and lab guides, it offers all the
          support that graduate teachers need, while the ability to customise gives experienced
          teachers flexibility and freedom.
        </P>
      </ResourceAccessBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default NSWSyllabusPage;
